// extracted by mini-css-extract-plugin
module.exports = {"product-support":"Support_product-support__XHMGY"};